export interface Country {
  name: string;
  code: string;
  phonePrefix: string;
  flag: string;
}

export const countries: Country[] = [
  // Priority countries (Baltic region)
  { name: 'Estonia', code: 'EE', phonePrefix: '+372', flag: '🇪🇪' },
  { name: 'Finland', code: 'FI', phonePrefix: '+358', flag: '🇫🇮' },
  { name: 'Latvia', code: 'LV', phonePrefix: '+371', flag: '🇱🇻' },
  { name: 'Lithuania', code: 'LT', phonePrefix: '+370', flag: '🇱🇹' },

  // Rest of the countries in alphabetical order
  { name: 'Afghanistan', code: 'AF', phonePrefix: '+93', flag: '🇦🇫' },
  { name: 'Albania', code: 'AL', phonePrefix: '+355', flag: '🇦🇱' },
  { name: 'Algeria', code: 'DZ', phonePrefix: '+213', flag: '🇩🇿' },
  { name: 'Andorra', code: 'AD', phonePrefix: '+376', flag: '🇦🇩' },
  { name: 'Angola', code: 'AO', phonePrefix: '+244', flag: '🇦🇴' },
  { name: 'Argentina', code: 'AR', phonePrefix: '+54', flag: '🇦🇷' },
  { name: 'Armenia', code: 'AM', phonePrefix: '+374', flag: '🇦🇲' },
  { name: 'Australia', code: 'AU', phonePrefix: '+61', flag: '🇦🇺' },
  { name: 'Austria', code: 'AT', phonePrefix: '+43', flag: '🇦🇹' },
  { name: 'Azerbaijan', code: 'AZ', phonePrefix: '+994', flag: '🇦🇿' },
  { name: 'Bahrain', code: 'BH', phonePrefix: '+973', flag: '🇧🇭' },
  { name: 'Bangladesh', code: 'BD', phonePrefix: '+880', flag: '🇧🇩' },
  { name: 'Belarus', code: 'BY', phonePrefix: '+375', flag: '🇧🇾' },
  { name: 'Belgium', code: 'BE', phonePrefix: '+32', flag: '🇧🇪' },
  { name: 'Belize', code: 'BZ', phonePrefix: '+501', flag: '🇧🇿' },
  { name: 'Benin', code: 'BJ', phonePrefix: '+229', flag: '🇧🇯' },
  { name: 'Bhutan', code: 'BT', phonePrefix: '+975', flag: '🇧🇹' },
  { name: 'Bolivia', code: 'BO', phonePrefix: '+591', flag: '🇧🇴' },
  { name: 'Bosnia and Herzegovina', code: 'BA', phonePrefix: '+387', flag: '🇧🇦' },
  { name: 'Botswana', code: 'BW', phonePrefix: '+267', flag: '🇧🇼' },
  { name: 'Brazil', code: 'BR', phonePrefix: '+55', flag: '🇧🇷' },
  { name: 'Brunei', code: 'BN', phonePrefix: '+673', flag: '🇧🇳' },
  { name: 'Bulgaria', code: 'BG', phonePrefix: '+359', flag: '🇧🇬' },
  { name: 'Burkina Faso', code: 'BF', phonePrefix: '+226', flag: '🇧🇫' },
  { name: 'Burundi', code: 'BI', phonePrefix: '+257', flag: '🇧🇮' },
  { name: 'Cambodia', code: 'KH', phonePrefix: '+855', flag: '🇰🇭' },
  { name: 'Cameroon', code: 'CM', phonePrefix: '+237', flag: '🇨🇲' },
  { name: 'Canada', code: 'CA', phonePrefix: '+1', flag: '🇨🇦' },
  { name: 'Cape Verde', code: 'CV', phonePrefix: '+238', flag: '🇨🇻' },
  { name: 'Central African Republic', code: 'CF', phonePrefix: '+236', flag: '🇨🇫' },
  { name: 'Chad', code: 'TD', phonePrefix: '+235', flag: '🇹🇩' },
  { name: 'Chile', code: 'CL', phonePrefix: '+56', flag: '🇨🇱' },
  { name: 'China', code: 'CN', phonePrefix: '+86', flag: '🇨🇳' },
  { name: 'Colombia', code: 'CO', phonePrefix: '+57', flag: '🇨🇴' },
  { name: 'Comoros', code: 'KM', phonePrefix: '+269', flag: '🇰🇲' },
  { name: 'Congo', code: 'CG', phonePrefix: '+242', flag: '🇨🇬' },
  { name: 'Costa Rica', code: 'CR', phonePrefix: '+506', flag: '🇨🇷' },
  { name: 'Croatia', code: 'HR', phonePrefix: '+385', flag: '🇭🇷' },
  { name: 'Cuba', code: 'CU', phonePrefix: '+53', flag: '🇨🇺' },
  { name: 'Cyprus', code: 'CY', phonePrefix: '+357', flag: '🇨🇾' },
  { name: 'Czech Republic', code: 'CZ', phonePrefix: '+420', flag: '🇨🇿' },
  { name: 'Denmark', code: 'DK', phonePrefix: '+45', flag: '🇩🇰' },
  { name: 'Djibouti', code: 'DJ', phonePrefix: '+253', flag: '🇩🇯' },
  { name: 'Dominica', code: 'DM', phonePrefix: '+1767', flag: '🇩🇲' },
  { name: 'Dominican Republic', code: 'DO', phonePrefix: '+1849', flag: '🇩🇴' },
  { name: 'Ecuador', code: 'EC', phonePrefix: '+593', flag: '🇪🇨' },
  { name: 'Egypt', code: 'EG', phonePrefix: '+20', flag: '🇪🇬' },
  { name: 'El Salvador', code: 'SV', phonePrefix: '+503', flag: '🇸🇻' },
  { name: 'Equatorial Guinea', code: 'GQ', phonePrefix: '+240', flag: '🇬🇶' },
  { name: 'Eritrea', code: 'ER', phonePrefix: '+291', flag: '🇪🇷' },
  { name: 'Ethiopia', code: 'ET', phonePrefix: '+251', flag: '🇪🇹' },
  { name: 'Fiji', code: 'FJ', phonePrefix: '+679', flag: '🇫🇯' },
  { name: 'France', code: 'FR', phonePrefix: '+33', flag: '🇫🇷' },
  { name: 'Gabon', code: 'GA', phonePrefix: '+241', flag: '🇬🇦' },
  { name: 'Gambia', code: 'GM', phonePrefix: '+220', flag: '🇬🇲' },
  { name: 'Georgia', code: 'GE', phonePrefix: '+995', flag: '🇬🇪' },
  { name: 'Germany', code: 'DE', phonePrefix: '+49', flag: '🇩🇪' },
  { name: 'Ghana', code: 'GH', phonePrefix: '+233', flag: '🇬🇭' },
  { name: 'Greece', code: 'GR', phonePrefix: '+30', flag: '🇬🇷' },
  { name: 'Grenada', code: 'GD', phonePrefix: '+1473', flag: '🇬🇩' },
  { name: 'Guatemala', code: 'GT', phonePrefix: '+502', flag: '🇬🇹' },
  { name: 'Guinea', code: 'GN', phonePrefix: '+224', flag: '🇬🇳' },
  { name: 'Guinea-Bissau', code: 'GW', phonePrefix: '+245', flag: '🇬🇼' },
  { name: 'Guyana', code: 'GY', phonePrefix: '+592', flag: '🇬🇾' },
  { name: 'Haiti', code: 'HT', phonePrefix: '+509', flag: '🇭🇹' },
  { name: 'Honduras', code: 'HN', phonePrefix: '+504', flag: '🇭🇳' },
  { name: 'Hungary', code: 'HU', phonePrefix: '+36', flag: '🇭🇺' },
  { name: 'Iceland', code: 'IS', phonePrefix: '+354', flag: '🇮🇸' },
  { name: 'India', code: 'IN', phonePrefix: '+91', flag: '🇮🇳' },
  { name: 'Indonesia', code: 'ID', phonePrefix: '+62', flag: '🇮🇩' },
  { name: 'Iran', code: 'IR', phonePrefix: '+98', flag: '🇮🇷' },
  { name: 'Iraq', code: 'IQ', phonePrefix: '+964', flag: '🇮🇶' },
  { name: 'Ireland', code: 'IE', phonePrefix: '+353', flag: '🇮🇪' },
  { name: 'Israel', code: 'IL', phonePrefix: '+972', flag: '🇮🇱' },
  { name: 'Italy', code: 'IT', phonePrefix: '+39', flag: '🇮🇹' },
  { name: 'Ivory Coast', code: 'CI', phonePrefix: '+225', flag: '🇨🇮' },
  { name: 'Jamaica', code: 'JM', phonePrefix: '+1876', flag: '🇯🇲' },
  { name: 'Japan', code: 'JP', phonePrefix: '+81', flag: '🇯🇵' },
  { name: 'Jordan', code: 'JO', phonePrefix: '+962', flag: '🇯🇴' },
  { name: 'Kazakhstan', code: 'KZ', phonePrefix: '+7', flag: '🇰🇿' },
  { name: 'Kenya', code: 'KE', phonePrefix: '+254', flag: '🇰🇪' },
  { name: 'Kiribati', code: 'KI', phonePrefix: '+686', flag: '🇰🇮' },
  { name: 'Kosovo', code: 'XK', phonePrefix: '+383', flag: '🇽🇰' },
  { name: 'Kuwait', code: 'KW', phonePrefix: '+965', flag: '🇰🇼' },
  { name: 'Kyrgyzstan', code: 'KG', phonePrefix: '+996', flag: '🇰🇬' },
  { name: 'Laos', code: 'LA', phonePrefix: '+856', flag: '🇱🇦' },
  { name: 'Lebanon', code: 'LB', phonePrefix: '+961', flag: '🇱🇧' },
  { name: 'Lesotho', code: 'LS', phonePrefix: '+266', flag: '🇱🇸' },
  { name: 'Liberia', code: 'LR', phonePrefix: '+231', flag: '🇱🇷' },
  { name: 'Libya', code: 'LY', phonePrefix: '+218', flag: '🇱🇾' },
  { name: 'Liechtenstein', code: 'LI', phonePrefix: '+423', flag: '🇱🇮' },
  { name: 'Luxembourg', code: 'LU', phonePrefix: '+352', flag: '🇱🇺' },
  { name: 'Macedonia', code: 'MK', phonePrefix: '+389', flag: '🇲🇰' },
  { name: 'Madagascar', code: 'MG', phonePrefix: '+261', flag: '🇲🇬' },
  { name: 'Malawi', code: 'MW', phonePrefix: '+265', flag: '🇲🇼' },
  { name: 'Malaysia', code: 'MY', phonePrefix: '+60', flag: '🇲🇾' },
  { name: 'Maldives', code: 'MV', phonePrefix: '+960', flag: '🇲🇻' },
  { name: 'Mali', code: 'ML', phonePrefix: '+223', flag: '🇲🇱' },
  { name: 'Malta', code: 'MT', phonePrefix: '+356', flag: '🇲🇹' },
  { name: 'Marshall Islands', code: 'MH', phonePrefix: '+692', flag: '🇲🇭' },
  { name: 'Mauritania', code: 'MR', phonePrefix: '+222', flag: '🇲🇷' },
  { name: 'Mauritius', code: 'MU', phonePrefix: '+230', flag: '🇲🇺' },
  { name: 'Mexico', code: 'MX', phonePrefix: '+52', flag: '🇲🇽' },
  { name: 'Micronesia', code: 'FM', phonePrefix: '+691', flag: '🇫🇲' },
  { name: 'Moldova', code: 'MD', phonePrefix: '+373', flag: '🇲🇩' },
  { name: 'Monaco', code: 'MC', phonePrefix: '+377', flag: '🇲🇨' },
  { name: 'Mongolia', code: 'MN', phonePrefix: '+976', flag: '🇲🇳' },
  { name: 'Montenegro', code: 'ME', phonePrefix: '+382', flag: '🇲🇪' },
  { name: 'Morocco', code: 'MA', phonePrefix: '+212', flag: '🇲🇦' },
  { name: 'Mozambique', code: 'MZ', phonePrefix: '+258', flag: '🇲🇿' },
  { name: 'Myanmar', code: 'MM', phonePrefix: '+95', flag: '🇲🇲' },
  { name: 'Namibia', code: 'NA', phonePrefix: '+264', flag: '🇳🇦' },
  { name: 'Nauru', code: 'NR', phonePrefix: '+674', flag: '🇳🇷' },
  { name: 'Nepal', code: 'NP', phonePrefix: '+977', flag: '🇳🇵' },
  { name: 'Netherlands', code: 'NL', phonePrefix: '+31', flag: '🇳🇱' },
  { name: 'New Zealand', code: 'NZ', phonePrefix: '+64', flag: '🇳🇿' },
  { name: 'Nicaragua', code: 'NI', phonePrefix: '+505', flag: '🇳🇮' },
  { name: 'Niger', code: 'NE', phonePrefix: '+227', flag: '🇳🇪' },
  { name: 'Nigeria', code: 'NG', phonePrefix: '+234', flag: '🇳🇬' },
  { name: 'North Korea', code: 'KP', phonePrefix: '+850', flag: '🇰🇵' },
  { name: 'Norway', code: 'NO', phonePrefix: '+47', flag: '🇳🇴' },
  { name: 'Oman', code: 'OM', phonePrefix: '+968', flag: '🇴🇲' },
  { name: 'Pakistan', code: 'PK', phonePrefix: '+92', flag: '🇵🇰' },
  { name: 'Palau', code: 'PW', phonePrefix: '+680', flag: '🇵🇼' },
  { name: 'Palestine', code: 'PS', phonePrefix: '+970', flag: '🇵🇸' },
  { name: 'Panama', code: 'PA', phonePrefix: '+507', flag: '🇵🇦' },
  { name: 'Papua New Guinea', code: 'PG', phonePrefix: '+675', flag: '🇵🇬' },
  { name: 'Paraguay', code: 'PY', phonePrefix: '+595', flag: '🇵🇾' },
  { name: 'Peru', code: 'PE', phonePrefix: '+51', flag: '🇵🇪' },
  { name: 'Philippines', code: 'PH', phonePrefix: '+63', flag: '🇵🇭' },
  { name: 'Poland', code: 'PL', phonePrefix: '+48', flag: '🇵🇱' },
  { name: 'Portugal', code: 'PT', phonePrefix: '+351', flag: '🇵🇹' },
  { name: 'Qatar', code: 'QA', phonePrefix: '+974', flag: '🇶🇦' },
  { name: 'Romania', code: 'RO', phonePrefix: '+40', flag: '🇷🇴' },
  { name: 'Russia', code: 'RU', phonePrefix: '+7', flag: '🇷🇺' },
  { name: 'Rwanda', code: 'RW', phonePrefix: '+250', flag: '🇷🇼' },
  { name: 'Saint Kitts and Nevis', code: 'KN', phonePrefix: '+1869', flag: '🇰🇳' },
  { name: 'Saint Lucia', code: 'LC', phonePrefix: '+1758', flag: '🇱🇨' },
  { name: 'Saint Vincent and the Grenadines', code: 'VC', phonePrefix: '+1784', flag: '🇻🇨' },
  { name: 'Samoa', code: 'WS', phonePrefix: '+685', flag: '🇼🇸' },
  { name: 'San Marino', code: 'SM', phonePrefix: '+378', flag: '🇸🇲' },
  { name: 'Sao Tome and Principe', code: 'ST', phonePrefix: '+239', flag: '🇸🇹' },
  { name: 'Saudi Arabia', code: 'SA', phonePrefix: '+966', flag: '🇸🇦' },
  { name: 'Senegal', code: 'SN', phonePrefix: '+221', flag: '🇸🇳' },
  { name: 'Serbia', code: 'RS', phonePrefix: '+381', flag: '🇷🇸' },
  { name: 'Seychelles', code: 'SC', phonePrefix: '+248', flag: '🇸🇨' },
  { name: 'Sierra Leone', code: 'SL', phonePrefix: '+232', flag: '🇸🇱' },
  { name: 'Singapore', code: 'SG', phonePrefix: '+65', flag: '🇸🇬' },
  { name: 'Slovakia', code: 'SK', phonePrefix: '+421', flag: '🇸🇰' },
  { name: 'Slovenia', code: 'SI', phonePrefix: '+386', flag: '🇸🇮' },
  { name: 'Solomon Islands', code: 'SB', phonePrefix: '+677', flag: '🇸🇧' },
  { name: 'Somalia', code: 'SO', phonePrefix: '+252', flag: '🇸🇴' },
  { name: 'South Africa', code: 'ZA', phonePrefix: '+27', flag: '🇿🇦' },
  { name: 'South Korea', code: 'KR', phonePrefix: '+82', flag: '🇰🇷' },
  { name: 'South Sudan', code: 'SS', phonePrefix: '+211', flag: '🇸🇸' },
  { name: 'Spain', code: 'ES', phonePrefix: '+34', flag: '🇪🇸' },
  { name: 'Sri Lanka', code: 'LK', phonePrefix: '+94', flag: '🇱🇰' },
  { name: 'Sudan', code: 'SD', phonePrefix: '+249', flag: '🇸🇩' },
  { name: 'Suriname', code: 'SR', phonePrefix: '+597', flag: '🇸🇷' },
  { name: 'Swaziland', code: 'SZ', phonePrefix: '+268', flag: '🇸🇿' },
  { name: 'Sweden', code: 'SE', phonePrefix: '+46', flag: '🇸🇪' },
  { name: 'Switzerland', code: 'CH', phonePrefix: '+41', flag: '🇨🇭' },
  { name: 'Syria', code: 'SY', phonePrefix: '+963', flag: '🇸🇾' },
  { name: 'Taiwan', code: 'TW', phonePrefix: '+886', flag: '🇹🇼' },
  { name: 'Tajikistan', code: 'TJ', phonePrefix: '+992', flag: '🇹🇯' },
  { name: 'Tanzania', code: 'TZ', phonePrefix: '+255', flag: '🇹🇿' },
  { name: 'Thailand', code: 'TH', phonePrefix: '+66', flag: '🇹🇭' },
  { name: 'Timor-Leste', code: 'TL', phonePrefix: '+670', flag: '🇹🇱' },
  { name: 'Togo', code: 'TG', phonePrefix: '+228', flag: '🇹🇬' },
  { name: 'Tonga', code: 'TO', phonePrefix: '+676', flag: '🇹🇴' },
  { name: 'Trinidad and Tobago', code: 'TT', phonePrefix: '+1868', flag: '🇹🇹' },
  { name: 'Tunisia', code: 'TN', phonePrefix: '+216', flag: '🇹🇳' },
  { name: 'Turkey', code: 'TR', phonePrefix: '+90', flag: '🇹🇷' },
  { name: 'Turkmenistan', code: 'TM', phonePrefix: '+993', flag: '🇹🇲' },
  { name: 'Tuvalu', code: 'TV', phonePrefix: '+688', flag: '🇹🇻' },
  { name: 'Uganda', code: 'UG', phonePrefix: '+256', flag: '🇺🇬' },
  { name: 'Ukraine', code: 'UA', phonePrefix: '+380', flag: '🇺🇦' },
  { name: 'United Arab Emirates', code: 'AE', phonePrefix: '+971', flag: '🇦🇪' },
  { name: 'United Kingdom', code: 'GB', phonePrefix: '+44', flag: '🇬🇧' },
  { name: 'United States', code: 'US', phonePrefix: '+1', flag: '🇺🇸' },
  { name: 'Uruguay', code: 'UY', phonePrefix: '+598', flag: '🇺🇾' },
  { name: 'Uzbekistan', code: 'UZ', phonePrefix: '+998', flag: '🇺🇿' },
  { name: 'Vanuatu', code: 'VU', phonePrefix: '+678', flag: '🇻🇺' },
  { name: 'Vatican City', code: 'VA', phonePrefix: '+379', flag: '🇻🇦' },
  { name: 'Venezuela', code: 'VE', phonePrefix: '+58', flag: '🇻🇪' },
  { name: 'Vietnam', code: 'VN', phonePrefix: '+84', flag: '🇻🇳' },
  { name: 'Yemen', code: 'YE', phonePrefix: '+967', flag: '🇾🇪' },
  { name: 'Zambia', code: 'ZM', phonePrefix: '+260', flag: '🇿🇲' },
  { name: 'Zimbabwe', code: 'ZW', phonePrefix: '+263', flag: '🇿🇼' },
];

// Helper function to get sorted countries list
export function getSortedCountries(): Country[] {
  const priorityCountryCodes = ['EE', 'FI', 'LV', 'LT'];

  const priorityCountries = countries.filter(c => priorityCountryCodes.includes(c.code));
  const otherCountries = countries.filter(c => !priorityCountryCodes.includes(c.code));

  // Sort other countries alphabetically by name
  otherCountries.sort((a, b) => a.name.localeCompare(b.name));

  return [...priorityCountries, ...otherCountries];
}

// Helper function to find country by phone prefix
export function findCountryByPrefix(phonePrefix: string): Country | undefined {
  // Remove any non-digit characters except +
  const cleanPrefix = phonePrefix.replace(/[^\d+]/g, '');

  // Try exact match first
  const exactMatch = countries.find(c => c.phonePrefix === cleanPrefix);
  if (exactMatch) return exactMatch;

  // Try partial match (for cases where user types without +)
  const partialMatch = countries.find(c =>
    c.phonePrefix === `+${cleanPrefix}` ||
    c.phonePrefix.substring(1) === cleanPrefix
  );

  return partialMatch;
}

// Helper function to parse phone number with country code
export function parsePhoneNumber(fullNumber: string): { country: Country | undefined; number: string } {
  if (!fullNumber) {
    return { country: undefined, number: '' };
  }

  // Clean the number
  const cleaned = fullNumber.replace(/[^\d+]/g, '');

  // Try to match against known country codes (sorted by prefix length descending)
  const sortedByPrefixLength = [...countries].sort((a, b) =>
    b.phonePrefix.length - a.phonePrefix.length
  );

  for (const country of sortedByPrefixLength) {
    if (cleaned.startsWith(country.phonePrefix)) {
      return {
        country,
        number: cleaned.substring(country.phonePrefix.length)
      };
    }
    // Also try without the + sign
    const prefixWithoutPlus = country.phonePrefix.substring(1);
    if (cleaned.startsWith(prefixWithoutPlus)) {
      return {
        country,
        number: cleaned.substring(prefixWithoutPlus.length)
      };
    }
  }

  // Default to Estonia if no match found
  return {
    country: countries.find(c => c.code === 'EE'),
    number: cleaned
  };
}

// Helper function to format phone number for display
export function formatPhoneNumber(country: Country, number: string): string {
  // This is a simple formatter - can be enhanced with country-specific formatting
  return `${country.phonePrefix} ${number}`;
}

// Helper function to validate phone number
export function validatePhoneNumber(country: Country, number: string): boolean {
  // Remove all non-digit characters
  const cleanNumber = number.replace(/\D/g, '');

  // Basic validation rules by country
  // This can be expanded with more specific rules per country
  switch (country.code) {
    case 'EE': // Estonia
      return cleanNumber.length >= 7 && cleanNumber.length <= 8;
    case 'FI': // Finland
      return cleanNumber.length >= 5 && cleanNumber.length <= 12;
    case 'LV': // Latvia
      return cleanNumber.length === 8;
    case 'LT': // Lithuania
      return cleanNumber.length === 8;
    case 'US': // United States
    case 'CA': // Canada
      return cleanNumber.length === 10;
    case 'GB': // United Kingdom
      return cleanNumber.length === 10 || cleanNumber.length === 11;
    default:
      // Generic validation: between 4 and 15 digits
      return cleanNumber.length >= 4 && cleanNumber.length <= 15;
  }
}